import type { PropsWithChildren } from 'react';

type TitleProps = PropsWithChildren;

export function Title(props: TitleProps) {
  const { children } = props;
  return <h1 className="text-2xl font-semibold">{children}</h1>;
}
